import React, { useState } from "react";
import RCAReportView from "./RCAReportView";
import AssetHealthReportView from "./AssetHealthAnalysisView";
import ApplicationHealthAnalysisView from "./ApplicationHealthAnalysisView";

const REPORTS = [
  {
    id: "rca",
    label: "AI-Powered Root Cause Analysis",
    description:
      "How reliably the AI diagnoses incident root cause, and how often it resolves without a human",
    component: RCAReportView,
  },
  {
    id: "application-health",
    label: "Application Health Analysis",
    description:
      "SLA uptime availability, application MTTR, and incident breakdown across business services",
    component: ApplicationHealthAnalysisView,
  },
  {
    id: "asset-health",
    label: "Asset Health Analysis",
    description: "Average calculated health and asset counts for each CMDB category",
    component: AssetHealthReportView,
  },
];

export default function AnalyticsView() {
  const [activeReport, setActiveReport] = useState(REPORTS[0].id);

  const report = REPORTS.find((item) => item.id === activeReport) || REPORTS[0];
  const ReportComponent = report.component;

  return (
    <div className="analytics-view">
      <div className="analytics-view__header">
        <div className="analytics-view__heading">
          <h1 className="analytics-view__title">Analytics</h1>
          <p className="analytics-view__subtitle">{report.description}</p>
          <label className="analytics-view__picker">
            <span className="analytics-view__picker-label">Report</span>
            <select
              className="analytics-view__picker-select"
              value={activeReport}
              onChange={(e) => setActiveReport(e.target.value)}
            >
              {REPORTS.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      <ReportComponent />
    </div>
  );
}
